export default __webpack_public_path__ + "images/Sarah R. Opperman Leadership Institute_Lockup_Vert_MaroonGold[68].png";